import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    height: fit-content;
    width: 100%;

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 50%;
        margin-top: 200px;
        transform: translateX(-50%);
    }

    .op {
        position: absolute;
        right: 0;
        margin-top: -72px;
        width: fit-content;
        padding: 16px;
        z-index: 1001;
    }

    .zero {
        color: ${({ theme }) => theme.colors.interfaceText400};
        padding-left: 8px;
    }

    @media (max-width: 1000px) {
        min-width: 1200px;        
    }
`
